import { Box, Alert, AlertTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatDateFromUTC } from "../../utils/FormatDateFromUTC";
import { formatHourFromUTC } from "../../utils/FormatHourFromUTC";

export default function NotificationItem({ notif, onClose }) {
  return (
    <Box sx={{ width: "100%" }}>
      <Alert
        severity={notif.category === "INFO" ? "info" : "warning"}
        sx={{ mb: 2 }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        }
      >
        <AlertTitle>
          <b>{notif.title}</b>
        </AlertTitle>
        <div>{notif.msg}</div>
        <div style={{ marginTop: "6px" }}>
          <small>
            <i>
              {formatDateFromUTC(notif.start_date)} -{" "}
              {formatHourFromUTC(notif.start_date)}
            </i>
          </small>
        </div>
      </Alert>
    </Box>
  );
}
